document.addEventListener('DOMContentLoaded', function() {
  const logos = document.getElementById('logos');
  const wrapper = document.getElementById('logos-wrapper');

  if (logos && wrapper) {
    const clone = logos.cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(clone);

    // Animate the wrapper containing both copies
    wrapper.classList.add('animate-infinite-scroll');
  }
});
